export const CARS_BOOKED_STATE_ASSIGNED = 'assigned'
export const CARS_BOOKED_STATE_NOT_ASSIGNED = 'not-assigned'
export const CARS_BOOKED_STATE_PENDING = 'pending'
export const CARS_BOOKED_STATE_BLIND_PLUS = 'blind plus'

export const isCarsBookedAssignedState = (assignedState) =>
  assignedState === CARS_BOOKED_STATE_ASSIGNED

export const isCarsBookedAssigned = (car) =>
  isCarsBookedAssignedState(car?.assignedState) || !!car?.isAssignedToPartner
